import {
    CompanyDetailsFromTaxProps,
    CompanyDetailsFromTaxResp,
    PartnerRegistrationRequest,
    PartnerRegistrationResponse,
    RegistrationRequest,
} from '../../models/Authentication/Registration';
import httpApi from '../api/httpApi';

const useRegistration = () => {
    const REGISTER_URL = '/api/v1/register';
    const PARTNER_REGISTER_URL = 'api/v1/partner-registration';
    const TAX_INFORMATION = 'api/v1/vat-info';

    const makeRequestBody = (data): RegistrationRequest => {
        return {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            phone: data.phone,
            company: data.company,
            tax_number: data.tax_number,
            default_stock: data.default_stock,
            country: data.country,
            postcode: data.postcode,
            city: data.city,
            address1: data.address1,
            address2: data.address2,
            password: data.password,
            password_confirmation: data.password_confirmation,
            terms_of_service: Number(data.terms_of_service),
            has4322: Number(data.has4322),
            note: data.note,
        };
    };

    const makeRequestBodyPartner = (data): PartnerRegistrationRequest => {
        return {
            email: data.email,
            phone: data.phone,
            company: data.company,
            store: data.store,
            privacy_notice: Number(data.privacy_notice),
            note: data.note,
        };
    };
    const sendRegistration = (
        data: RegistrationRequest
    ): Promise<RegistrationRequest> => {
        return httpApi
            .post<RegistrationRequest>(REGISTER_URL, makeRequestBody(data))
            .then((resp) => {
                return resp.getData();
            });
    };

    const sendPartnerRegistration = (
        data: PartnerRegistrationRequest
    ): Promise<PartnerRegistrationResponse> => {
        return httpApi
            .post<PartnerRegistrationResponse>(
                PARTNER_REGISTER_URL,
                makeRequestBodyPartner(data)
            )
            .then((resp) => {
                return resp.getData();
            });
    };

    const getCompanyInfoFromVat = (
        data: CompanyDetailsFromTaxProps
    ): Promise<CompanyDetailsFromTaxResp> => {
        return httpApi
            .post<CompanyDetailsFromTaxResp>(TAX_INFORMATION, data)
            .then((resp) => {
                return resp.getData();
            });
    };

    return {
        sendRegistration,
        sendPartnerRegistration,
        getCompanyInfoFromVat,
    };
};

export default useRegistration;
